export default __webpack_public_path__ + "static/Dashboard-ss-1e5ce6d883ea0736c581611c6cb19a67.png";